import {
  Accessibility,
  Activity,
  Anchor,
  Bike,
  Boxes,
  BriefcaseMedical,
  Building,
  Bus,
  CalendarX,
  Car,
  CarFront,
  Caravan,
  CircleEllipsis,
  CreditCard,
  Dog,
  Flower2,
  Frame,
  Gem,
  Globe,
  Hammer,
  HeartPulse,
  Hourglass,
  House,
  KeyRound,
  Lock,
  PartyPopper,
  PawPrint,
  Plane,
  Sailboat,
  Scale,
  ShieldCheck,
  Smartphone,
  Smile,
  Sofa,
  Sprout,
  Stethoscope,
  Tent,
  Truck,
  Users,
  Wrench,
  Zap,
  type LucideIcon,
} from "lucide-react";
import type {
  InsuranceType,
  InsuranceTypeFamily,
} from "@/lib/data/insurance";

/** One icon per represented insurance type. */
export const INSURANCE_TYPE_ICONS: Record<InsuranceType, LucideIcon> = {
  PERSONAL_LIABILITY: ShieldCheck,
  CONTENTS: Sofa,
  BUILDINGS: Building,
  VALUABLES: Gem,
  GLASS: Frame,
  HOME_CONSTRUCTION: Hammer,
  RECREATIONAL_HOME: Tent,
  HOUSEBOAT: Anchor,
  CAR: Car,
  MOTORCYCLE: Bike,
  MOPED: Bike,
  BICYCLE: Bike,
  MOBILITY_SCOOTER: Accessibility,
  MICRO_MOBILITY: Zap,
  CLASSIC_VEHICLE: CarFront,
  CARAVAN: Caravan,
  CAMPER: Bus,
  TRAILER: Truck,
  BOAT: Sailboat,
  BREAKDOWN_ASSISTANCE: Wrench,
  VEHICLE_OCCUPANTS: Users,
  RENTAL_VEHICLE_EXCESS: KeyRound,
  TRAVEL: Plane,
  TRAVEL_CANCELLATION: CalendarX,
  HEALTH_BASIC: HeartPulse,
  HEALTH_SUPPLEMENTARY: Stethoscope,
  DENTAL: Smile,
  INTERNATIONAL_HEALTH: Globe,
  ACCIDENT: BriefcaseMedical,
  LEGAL_EXPENSES: Scale,
  DISABILITY: Activity,
  PAYMENT_PROTECTION: CreditCard,
  CYBER: Lock,
  TERM_LIFE: Hourglass,
  LIFE: Sprout,
  FUNERAL: Flower2,
  PET: Dog,
  HORSE: PawPrint,
  ELECTRONICS: Smartphone,
  WEDDING_EVENT: PartyPopper,
  PACKAGE: Boxes,
  OTHER_PERSONAL: CircleEllipsis,
};

/** One icon per family of insurance types. */
export const INSURANCE_FAMILY_ICONS: Record<InsuranceTypeFamily, LucideIcon> = {
  HOME: House,
  MOBILITY: Car,
  TRAVEL: Plane,
  HEALTH: HeartPulse,
  LEGAL_INCOME: Scale,
  LIFE: Sprout,
  ANIMALS: PawPrint,
  OTHER: Boxes,
};

/** Types worth a shortcut chip in the hero: the searches renters run first. */
export const INSURANCE_POPULAR_TYPES: InsuranceType[] = [
  "PERSONAL_LIABILITY",
  "CONTENTS",
  "HEALTH_BASIC",
  "TRAVEL",
  "CAR",
  "LEGAL_EXPENSES",
  "BICYCLE",
  "PET",
];
